module.exports = __webpack_public_path__ + "assets/img/empty.ccdf6506.svg";